module.exports = __webpack_public_path__ + "assets/10a6eaa860dacf06eb233756c8229ae5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/bg/video.mp4
// module id = 363
// module chunks = 1